/* eslint-disable no-plusplus */
import {
    Avatar,
    List, ListItem, ListItemText,
} from 'appkit-react';

const PasswordHints = ({
    password, firstName, lastName,
}) => {
    /* function to check upper case validity of password */
    const checkUpperCase = () => {
        const upperCaseLetters = /[A-Z]/g;
        if (password && password.trim() !== '' && password.match(upperCaseLetters)) {
            return true;
        }
        return false;
    };

    /* function to check lower case validity of password */
    const checkLowerCase = () => {
        const lowerCaseLetters = /[a-z]/g;
        if (password && password.trim() !== '' && password.match(lowerCaseLetters)) {
            return true;
        }
        return false;
    };

    /* function to check number validity of password */
    const checkNumber = () => {
        const numbers = /[0-9]/g;
        if (password && password.trim() !== '' && password.match(numbers)) {
            return true;
        }
        return false;
    };

    /* function to check special character validity of password */
    const checkSpecialChar = () => {
        const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (password && password.trim() !== '' && password.match(specialChars)) {
            return true;
        }
        return false;
    };

    /* function to check length validity of password */
    const checkLength = () => {
        const minLength = 8;
        const maxLength = 20;
        if (password && password.trim() !== '' && password.length >= minLength && password.length <= maxLength) {
            return true;
        }
        return false;
    };

    /* function to check no first name or last name validity of password */
    const checkName = () => {
        if (password && password.trim() !== '' && password !== firstName && password !== lastName) {
            return true;
        }
        return false;
    };

    const listItemSpanClassName = 'appkiticon icon-check-mark-fill a-font-14 a-text-green a-mr-5';

    const AvatarView = () => (
        <Avatar style={{ backgroundColor: 'rgb(19 18 18)', height: '0.5rem', width: '0.5rem' }} className="a-mr-10" label="" />
    );

    return (
        <List>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkLowerCase() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkLowerCase() ? '#22992E' : 'black' }}>One Lowercase character</ListItemText>
            </ListItem>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkUpperCase() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkUpperCase() ? '#22992E' : 'black' }}> One uppercase character</ListItemText>
            </ListItem>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkNumber() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkNumber() ? '#22992E' : 'black' }}>One number</ListItemText>
            </ListItem>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkSpecialChar() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkSpecialChar() ? '#22992E' : 'black' }}>One special character</ListItemText>
            </ListItem>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkLength() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkLength() ? '#22992E' : 'black' }}>
                    8 - 20 characters
                </ListItemText>
            </ListItem>
            <ListItem style={{ fontSize: '.800rem', paddingTop: 0 }}>
                {checkName() ? (
                    <span className={listItemSpanClassName} aria-hidden="true" />
                ) : (
                    AvatarView()
                )}
                <ListItemText style={{ color: checkName() ? '#22992E' : 'black' }}> No first or last name</ListItemText>
            </ListItem>
        </List>
    );
};

export default PasswordHints;
